var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStreamList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 27.5C11.125 27.5 9.9475 27.01 8.9675 26.03C7.9875 25.05 7.49834 23.8733 7.5 22.5V17.5C7.5 16.125 7.99 14.9475 8.97 13.9675C9.95 12.9875 11.1267 12.4983 12.5 12.5H47.5C48.875 12.5 50.0525 12.99 51.0325 13.97C52.0125 14.95 52.5017 16.1267 52.5 17.5V22.5C52.5 23.875 52.01 25.0525 51.03 26.0325C50.05 27.0125 48.8733 27.5017 47.5 27.5H12.5ZM12.5 47.5C11.125 47.5 9.9475 47.01 8.9675 46.03C7.9875 45.05 7.49834 43.8733 7.5 42.5V37.5C7.5 36.125 7.99 34.9475 8.97 33.9675C9.95 32.9875 11.1267 32.4983 12.5 32.5H47.5C48.875 32.5 50.0525 32.99 51.0325 33.97C52.0125 34.95 52.5017 36.1267 52.5 37.5V42.5C52.5 43.875 52.01 45.0525 51.03 46.0325C50.05 47.0125 48.8733 47.5017 47.5 47.5H12.5Z",
    fill: "#0E1F3C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 40,
    r: 2.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 20,
    r: 2.5,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStreamList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/streamList.c71523251af42da7a1a876ad9f846f22.svg";